import { Component } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { SwUpdate } from '@angular/service-worker';

export let browserRefresh = false;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Edge';
  public isSpinner = true;
  subscription: Subscription;
  constructor(private router: Router, private activeRoute: ActivatedRoute, public service: AuthService, private toast: ToastrService,
    private swUpdate: SwUpdate
  ) {
   
    this.subscription = this.router.events.subscribe((event) => {

      if (event instanceof NavigationStart) {
        browserRefresh = !this.router.navigated;
        // console.log('refreshed', browserRefresh);
      }
    });


  }
  ngOnInit(): void {

    try{
         if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(event => {
         console.log('SW Version Event:', event);
        if (event.type === 'VERSION_READY') {
          if (confirm('New version available. Load new version?')) {
            window.location.reload();
          }
        }
      });
    }
    }catch(err){
      console.log(err, 'error in sw');
    }
  
    let value = window.location.href;
    let data = value && value.split("=")[1];
    let code = data && data.split('#')[0];
    // console.log(code);
    setTimeout(() => {
      this.isSpinner = false;
    }, 500)
    if (code) {
      this.service.fbLogin(code).subscribe((resp: any) => {
        // setTimeout(() => {
        this.isSpinner = false;
        this.toast.success('Login Successful');
        // }, 2000);
        // console.log(resp, '/////');
        if (resp && resp.result.jwt) {
          this.service.getPageNameData('Home');
          window.localStorage.setItem('user_id', resp.result._id);
          window.localStorage.setItem('token', resp.result.jwt);
          this.service.getUserInfofromFB(resp.result._id).subscribe((data: any)=>{
            window.localStorage.setItem('full_name', data.result.first_name + " " + data.result.last_name)

            let payload = {
              "user_type": 'user',
              "fullname": data.result.first_name + " " + data.result.last_name
            
          }
          this.service.updateUser(payload, resp.result._id).subscribe(result => {
           
          })
          })
          this.service.getUserDetails().subscribe((user: any) => {
            let profileid = user.result?._source?.user_type ? user.result?._source?.user_type : 'user';
          localStorage.setItem('startegy', user.result.strategies[0]);            
            this.service.getRoleDetails(profileid).subscribe((role: any) => {
              let roleRightsJson = role.result._source.pages;
              this.isSpinner = false;
              this.toast.success('Login Successful');
          window.localStorage.setItem('user_devices', JSON.stringify(user.result._source.devices))

              window.localStorage.setItem('sideMenuList', JSON.stringify(roleRightsJson));
             window.localStorage.setItem('user_devices', JSON.stringify(user.result._source?.devices))

              this.router.navigate(['/dashboard']);
              this.service.getPageNameData('Home');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);               
           
            })
          })
          

        }
      }, error => {
        this.isSpinner = false;
      });
    }
    setTimeout(() => {
      localStorage.removeItem('socialMedia');
   }, 10000);

  }
  ngOnDestroy() {
    this.isSpinner = false;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
